<app-table-generator
    [tableInput]="tableGenInput"
    [widgetRef]="widgetRef"
    [showSearchBox]="!widgetRef.lightState"
></app-table-generator>
